import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-commercial-property-insurance.component.scss';
var FormItemBusinessCommercialPropertyInsurance = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessCommercialPropertyInsurance, _super);
    function FormItemBusinessCommercialPropertyInsurance(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessCommercialPropertyInsurance.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-business-commercial-property-insurance__button');
        this.formModal = this.element.closest('.modal.js-apply-now-modal');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
    };
    FormItemBusinessCommercialPropertyInsurance.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
    };
    FormItemBusinessCommercialPropertyInsurance.prototype.submitForm = function (pForm) {
        var _this = this;
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _cellNumber = this.form.querySelector("input[name=cell-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _product = this.form.querySelector("input[name=product]");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var _dateTime = "anytime";
        if (_date && _time) {
            if (_time.value !== "Anytime") {
                _dateTime = _date.value + " " + _time.value;
            }
        }
        var _postData = {
            'first': (_firstname ? _firstname.value : ""),
            'last': (_lastName ? _lastName.value : ""),
            'cell': (_cellNumber ? _cellNumber.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'product': (_product ? _product.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'business-name': (_businessName ? _businessName.value : ""),
            'besttimetoCall': _dateTime
        };
        this.showDisplayView("loader");
        // variables
        var url = '/services/SBIS_Handler_COZA.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), config).then(function (response) {
            // service ok
            if (!response) {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
                _this.showDisplayView("error");
            }
            else if (response.data) {
                if (response.data.toString().toLowerCase().includes("invalid")) {
                    _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                    _this.showDisplayView("error");
                }
                else {
                    _this.analyticsService.dtmFormComplete('complete', response.data);
                    _this.showDisplayView("success");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                _this.showDisplayView("error");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessCommercialPropertyInsurance.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemBusinessCommercialPropertyInsurance;
}(Base));
export { FormItemBusinessCommercialPropertyInsurance };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-commercial-property-insurance/form-item-business-commercial-property-insurance.component.ts
// module id = 857
// module chunks = 0